import { render, staticRenderFns } from "./PosteMatchingDetails.vue?vue&type=template&id=20f45cf4&"
import script from "./PosteMatchingDetails.vue?vue&type=script&lang=ts&"
export * from "./PosteMatchingDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports